import { render, staticRenderFns } from "./TheHeaderLine.vue?vue&type=template&id=70a89346&scoped=true&"
import script from "./TheHeaderLine.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheHeaderLine.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TheHeaderLine.vue?vue&type=style&index=0&id=70a89346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a89346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a89346')) {
      api.createRecord('70a89346', component.options)
    } else {
      api.reload('70a89346', component.options)
    }
    module.hot.accept("./TheHeaderLine.vue?vue&type=template&id=70a89346&scoped=true&", function () {
      api.rerender('70a89346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeaderLine.vue"
export default component.exports